<template>
  <div id="app">
    <!-- <transition :name="transitionName">
      <router-view class="child-view"></router-view>
    </transition> -->
    <router-view></router-view>

    <!-- 预加载的图片 -->
    <div style="display: none">
      <img src="./assets/p8/bg-hasprize.jpg" />
      <img src="./assets/p8/bg-noprize.jpg" />
      <img id="head-image-box" src="./assets/p8/head-image-box.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
    
    }
  },
  mounted () {
    // app基本渲染完成，开始一些不影响页面的初始化工作
    console.log('====>App mounted')

    // 至少等1s，最多等2s，去掉loading页
    const waitPageReady = setInterval(() => {
      if (this.$store.state.pageReady) {
        this.hideLoading()
        clearInterval(waitPageReady)
      }
    }, 50)

    setTimeout(() => {
      this.hideLoading()
      clearInterval(waitPageReady)
    }, 2000)
  },
  methods: {
    hideLoading() {
      document.getElementsByClassName('loading-inner')[0].style.width = '100%'
      document.getElementsByClassName('loading')[0].style.opacity = 0
      setTimeout(() => {
        document.getElementsByClassName('loading')[0].style.display = 'none'
      }, 300)

      // 音频
      const player = document.getElementById('mp3-home')
      if(location.href.indexOf('result') === -1 && location.href.indexOf('share') === -1 && location.href.indexOf('upload') === -1){
        player.play()
      }
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

/* 页面，默认100%大 */
.page{
  width: 100%;
  height: 100%;
  min-height: 32rem;
  overflow: hidden;
}

/* 页面的背景图，默认全覆盖 */
.bg{
  background-position: 50% 50%;
  background-size: cover;
  background-repeat: no-repeat;
}


/* 页面切换动画 */
.fade-enter-active, .fade-leave-active {
  transition: opacity .75s ease;
}
.fade-enter, .fade-leave-active {
  opacity: 0;
}
.child-view {
  position: absolute;
  transition: all .75s cubic-bezier(.55,0,.1,1);
}
.slide-left-enter, .slide-right-leave-active {
  opacity: 0;
  -webkit-transform: translate(30px, 0);
  transform: translate(30px, 0);
}
.slide-left-leave-active, .slide-right-enter {
  opacity: 0;
  -webkit-transform: translate(-30px, 0);
  transform: translate(-30px, 0);
}
</style>
